"use strict";

angular.module("customer")
.controller("DepositSlipListController", function(
    $scope, $filter, $stateParams, moment, DepositSlipService, StateExtensionService, PaymentMethodsService,
    UserCustomerService
) {
    $scope.methodChoicesLocalized = PaymentMethodsService.getMethodChoicesLocalized();

    if ($stateParams.creation_date_start && $stateParams.creation_date_end) {
        $scope.params = angular.extend({}, $stateParams);
    }
    else {
        var defaultStartDate = moment().startOf('day').subtract(7, "days").toISOString();
        var defaultEndDate = moment().toISOString()
        $scope.params = {
            creation_date_start: defaultStartDate,
            creation_date_end: defaultEndDate
        };
        StateExtensionService.updateUrlParams($scope.params);
    }

    UserCustomerService.release().then(function onSuccess() {
        $scope.data = DepositSlipService.query($scope.params);
    });

    $scope.$on("dateFilterUpdated", function(event, dateFilter) {
        StateExtensionService.updateUrlParams(dateFilter);
        $scope.params = angular.extend({}, dateFilter);
        $scope.data = DepositSlipService.query($scope.params);
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/deposit-slip/deposit-slip-list.controller.js
// module id = 909
// module chunks = 0